// extracted by mini-css-extract-plugin
export default {"container":"fZ-z","heading":"gZ-z","links":"hZ-z","copy":"iZ-z","subCopy":"jZ-z","linksLeft":"kZ-z","linksCenter":"lZ-z","linksRight":"mZ-z","link":"nZ-z","onlyLink":"oZ-z"};